import React, { Component } from "react";
import { Row, Col, Button, Empty } from "antd";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
import RmxCover from "../../assets/images/distributors-banner.jpg";
import DistributorsIcon from "../../assets/images/distributors-icon.png";
import ManufacturePlantInfo from "../../components/EmployeCard/manufacturePlant";
import RmxDashboard from "../../components/DashboardRmx";
import ManufacturingPlants from "../../components/DashboardRmx/manufacturingPlants";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import LoaderGif from "../../assets/images/ie_loader.gif";
import SurfaceTechLogo from "../../assets/images/surface-tech-logo.png";
import RmxMainHeader from "../../components/rmxHeader/mainHeader";
import { AiOutlineTwitter, FaFacebookF, FaInstagram } from "react-icons/all";
// import SurfaceLogo from '../../assets/images/surface-logo.png'

class PlantDirectory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        per_page: 12,
        zipcode: "",
        search: "",
      },
      isnavShow: false,
    };
  }

  componentDidMount() {
    const { getRmxCompaniesDetails, clearStoreName } = this.props;
    getRmxCompaniesDetails(this.state.filter);
    // clearStoreName()
  }
  componentDidUpdate(preProps, preState) {
    const { getRmxCompaniesDetails } = this.props;
    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          total_records: this.props?.metaData?.total_records,
          current_records: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filter.search !== this.state.filter.search ||
      preState.filter.column !== this.state.filter.column ||
      preState.filter.per_page !== this.state.filter.per_page ||
      preState.filter.page !== this.state.filter.page ||
      preState.filter.zipcode !== this.state.filter.zipcode
    ) {
      getRmxCompaniesDetails(this.state.filter);
    }
  }
  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };

  onChangeFilter = (value) => {
    console.log("onfilter===>", value);
    this.setState({
      filter: {
        ...this.state.filter,
        zipcode: value,
      },
    });
  };
  onFilterSearch = (value) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: value,
      },
    });
  };
  render() {
    const { rmxCompany, metaData } = this.props;
    return (
      <Row justify="center" >
        <Col span={24} id="rmx-container">
          <Row align="middle">
            <Col xl={2} lg={2} md={4} xs={2} sm={2} style={{ paddingLeft: '20px' }}>
              <img src={SurfaceTechLogo} height="20px" />
            </Col>
            {/* <Col xl={20} lg={20} md={24} xs={24} sm={24}>
              <Row align="middle" justify="center">
                <Col xl={2} xs={6} sm={6} md={4} lg={2}>
                  <a
                    href="https://www.surface-tech.com/about-m/"
                    target="_blank"
                  >
                    <h4 className="color-white nav-font-bold">HOME</h4>
                  </a>
                </Col>
                <Col xl={2} xs={6} sm={6} md={4} lg={2}>
                  <a
                    href="https://www.surface-tech.com/asphalt-overview-2/"
                    target="_blank"
                  >
                    <h4 className="color-white nav-font-bold ">
                      ABOUT
                    </h4>
                  </a>
                </Col>
                <Col xl={2} xs={7} sm={6} md={4} lg={4}>
                  <a
                    href="https://www.surface-tech.com/concrete_platform_2017/"
                    target="_blank"
                  >
                    <h4 className="color-white nav-font-bold ">
                      TECHNOLOGY
                    </h4>
                  </a>
                </Col>
                <Col xl={2} xs={6} sm={6} md={4} lg={2}>
                  <a
                    href="https://surface-tech.com/trkr-overview/"
                    target="_blank"
                  >
                    <h4 className="color-white nav-font-bold ">NEWS</h4>
                  </a>
                </Col>
                <Col xl={2} xs={6} sm={6} md={4} lg={2}>
                  <a
                    href="https://www.surface-tech.com/contact-2017/"
                    target="_blank"
                  >
                    <h4 className="color-white nav-font-bold ">
                      CONTACT
                    </h4>
                  </a>
                </Col>
              </Row>
            </Col> */}
            {/* <Col xl={2} lg={2} md={2} xs={24} sm={24} style={{ paddingRight: '20px' }}>
              <Row justify="end">
                <Col xl={8} lg={8} md={8} >
                  <AiOutlineTwitter color="white" size="25" />
                </Col>
                <Col xl={8} lg={8} md={8}>
                  <FaFacebookF color="white" size="25" />
                </Col>
                <Col xl={8} lg={8} md={8}>
                  <FaInstagram color="white" size="25" />
                </Col>
              </Row>
            </Col> */}
          </Row>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24} sm={24} style={{ position: 'absolute' }}>
          <Row justify="center">
            <Col span={24}>
              <RmxDashboard backgroundRmxImage={RmxCover} />
            </Col>
            <Col span={24}>
              <ManufacturingPlants
                RmxImage={DistributorsIcon}
                onChangeFilter={this.onChangeFilter}
                onFilterSearch={this.onFilterSearch}
              />
            </Col>
            <Col xl={24} xs={24} sm={24} md={24} lg={24}>
              <Row justify="center" gutter={[10, 0]}>
                {/* <a href={}></a> */}
                {!!rmxCompany?.length ? (
                  (rmxCompany || []).map((item, index) => {
                    return (
                      <Col
                        xl={5}
                        lg={6}
                        md={6}
                        xs={24}
                        sm={24}
                        onClick={() =>
                          window.open(
                            `${process.env.REACT_APP_LINK}://${item?.rmx_company_asset?.store_url}${process.env.REACT_APP_DOMAIN}/#/`,
                            "_self"
                          )
                        }
                      >
                        <ManufacturePlantInfo
                          backgroundImage={
                            item?.rmx_company_asset?.logo?.original
                          }
                          inputText={item?.rmx_company_asset?.store_name}
                          inputTitle={item?.rmx_company_asset?.description}
                        />
                      </Col>
                    );
                  })
                ) : this.props.isLoading ? (
                  <Col
                    span={24}
                    className="text-center"
                    style={{ marginTop: "30px", marginBottom: "40px" }}
                  >
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  </Col>
                ) : (
                  <Col
                    span={24}
                    className="text-center"
                    style={{ marginTop: "30px", marginBottom: "40px" }}
                  >
                    <Empty description="Nothing to show right now." />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
          {!!rmxCompany?.length && (
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="rmx-pagination"
            >
              <Row gutter={[5, 0]} justify="start">
                <Col className="tablePagination" xl={7}>
                  {`Displaying ${this.state.filter?.page !== this.state.filter.total_pages
                    ? this.state.filter?.per_page * this.state.filter?.page
                    : this.state.filter?.total_records
                    } of ${this.state.filter?.total_records}`}
                  <Button
                    type="link"
                    icon={<BsChevronLeft color="#686868" size={15} />}
                    onClick={this.previousPage}
                    disabled={this.state.filter.page === 1}
                  />
                  <Button
                    type="link"
                    icon={<BsChevronRight color="#686868" size={15} />}
                    onClick={this.currentPage}
                    disabled={
                      this.state.filter.total_pages === this.state.filter.page
                    }
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    rmxCompany: store.DashboardReducer.rmxCompanies,
    metaData: store.DashboardReducer.metaData,
    isLoading: store.DashboardReducer.isLodadingCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRmxCompaniesDetails: (params) =>
      dispatch(DashboardAction.getRmxCompanyReq(params)),
    // clearStoreName: () => dispatch(UserAction.clearStoreName())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlantDirectory);
